export default __webpack_public_path__ + "static/media/ATOM-BNB.02e1be3d.svg";